import React from 'react';
import { Instagram } from 'lucide-react';

const InstagramFeed = () => {
  return (
    <section data-testid="instagram-feed-section" className="py-24 px-6 bg-[#141414]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <Instagram className="w-10 h-10 text-[#E8651A] mx-auto mb-4" />
          <h2 className="font-['Oswald'] text-3xl sm:text-4xl text-[#F2EDE6] mb-2">
            @REVLINERALLY
          </h2>
          <p className="text-[#A19D98]">
            Follow us on Instagram for the latest rally photos and updates
          </p>
        </div>

        {/* Instagram Embed - Using SnapWidget or similar */}
        <div className="relative">
          {/* Placeholder grid that mimics Instagram posts */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
            {[...Array(6)].map((_, i) => (
              <a
                key={i}
                href="https://www.instagram.com/revlinerally/"
                target="_blank"
                rel="noopener noreferrer"
                className="aspect-square bg-[#1C1C1C] border border-[#2A2A2A] flex items-center justify-center group hover:border-[#E8651A] transition-colors"
              >
                <div className="text-center">
                  <Instagram className="w-8 h-8 text-[#2A2A2A] group-hover:text-[#E8651A] transition-colors mx-auto mb-2" />
                  <span className="text-[#2A2A2A] group-hover:text-[#E8651A] text-xs transition-colors">
                    View Post
                  </span>
                </div>
              </a>
            ))}
          </div>

          {/* Overlay with CTA */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent flex items-end justify-center pb-8 pointer-events-none">
            <a
              href="https://www.instagram.com/revlinerally/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary pointer-events-auto flex items-center gap-2"
            >
              <Instagram size={18} />
              Follow @revlinerally
            </a>
          </div>
        </div>

        {/* Note for embedding real feed */}
        <p className="text-center text-[#A19D98] text-xs mt-8">
          To display live Instagram posts, connect your Instagram account via{' '}
          <a 
            href="https://snapwidget.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#E8651A] hover:underline"
          >
            SnapWidget
          </a>{' '}
          or{' '}
          <a 
            href="https://elfsight.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#E8651A] hover:underline"
          >
            Elfsight
          </a>
        </p>
      </div>
    </section>
  );
};

export default InstagramFeed;
